/* global SVGImageElement, Q */

// nu merge direct cu _E("svg") --> NS

_SVG = new Proxy(() => { }, {  //
    get: function (o, type) {
        return o.hasOwnProperty(type) ? o[type] : function (Attr = {}, Prop = {}) {    // EX  _SVG.text   ( {width:$.conf._1w_-6,x:3,y:$.conf._1h_-3}   ,{ html:"BLA-BLA" , txy:[100,50]});
            if (_SVG_CUSTOM.hasOwnProperty(type)) {  // CUSTOM SVG ELEMENTS
                var G = _SVG_CUSTOM[type];
                switch (true) {
                    case typeof G === 'string':
                        return _SVG(G).setA(Attr).tail(Prop);  // apply -- below
                        break;
                    case typeof G === "function":
                        return G(Attr, Prop); // execut functia cu 2 argumente  
                        break;
                    default: // object ex _SVG.ball({fill:'red'})
                        return _SVG[G.type]({ ...G.attr, ...Attr }, Prop); // !!!BAC reference  --- trebuie copie pt attributele default --- sa nu apara efect cumulativ  
                        break;
                }
            }
            else {
                let e = document.createElementNS("http://www.w3.org/2000/svg", type);
                for (let [k, v] of Object.entries(Attr)) { // ATTRIBUTES
                    e.setAttribute(k, v);
                }
                for (let [k, v] of Object.entries(Prop)) {  // PROPERTIES
                    e[k] = v;
                }
                return e;
            }
        };
    },
    apply: function (o, p, str) {  // dom_like structure   EX : var Img = _SVG('<g><image  width="80"  href="media/img/hr/1631213274792.jpg" /></g>');
        var e = _SVG.svg();
        e.html = str;
        return e.first || e;
    }
});


_SVG_CUSTOM = {
    ball: {
        type: "circle",
        attr: { cx: 0, cy: 0, r: 1, fill: "none" }
    },

    // limit text to prop.length  and show all in title popup
    // EX   : g._(_SVG.paragraf({width: 100, height: 20, x: 70, y: 40, style: 'font-size:.75em ;'}, {html: (o.email || "---"), length: 24}));
    paragraf: function (attr = {}, prop = {}) {
        var text = (prop.html || prop.text || attr.text || attr.html || "..."), title = null;
        if (text.length > prop.length) { // ("abc" > undefined) is false
            title = text;
            text = text.substr(0, prop.length - 4) + "...";
        }
        let p = _E('p', text);
        title && p.setA({ title });
        delete prop.html;
        delete prop.text;
        for (let [k, v] of Object.entries(prop)) {
            p[k] = v;
        }
        return _SVG.foreignObject(attr).css({ overflow: "visible" })._(p);
    },
    p: function (a, b) {
        return _SVG.paragraf(a, b);
    },
    icon: function (name, attr) {
        var e = _SVG.foreignObject(attr);
        e.style.overflow = 'visible';
        e._(_E('icon', name));
        return e;
    },
    tag: function (attr = {}, prop = {}) { // !!!BAC>>>  foreignObject are nevoie de height si width ca sa afisheze ceva  -- face clipping pe continut
        var e = _SVG.foreignObject(attr, prop);
        e.style.overflow = 'visible';
        return e;
    },
    bar: function (attr = {}, prop = {}) {
        let e = _SVG.tag(attr, prop);
        return e._(_E().css("width:100%;height:100%"));
    },
    alert: '<path d="M 7.04 17 L 12.95 17 C 12.71 18.42 11.48 19.5 10 19.5 C 8.51 19.5 7.28 18.42 7.04 17 Z M 10 0 C 14.14 0 17.5 3.36 17.5 7.5 L 17.5 11.5 L 18.91 14.66 C 18.97 14.78 19 14.91 19 15.05 C 19 15.57 18.57 16 18.05 16 L 1.95 16 C 1.81 16 1.68 15.97 1.56 15.91 C 1.08 15.7 0.87 15.14 1.08 14.66 L 2.5 11.5 L 2.5 7.49 L 2.5 7.24 C 2.64 3.21 5.95 0 10 0 Z" />',
    person: '<path d="M 15.75 12 C 16.99 12 18 13 18 14.25 L 18 15.16 C 18 15.74 17.82 16.3 17.49 16.76 C 15.94 18.93 13.42 20 10 20 C 6.58 20 4.05 18.93 2.51 16.76 C 2.18 16.3 2 15.74 2 15.17 L 2 14.25 C 2 13 3.01 12 4.25 12 L 15.75 12 Z M 10 0 C 12.76 0 15 2.24 15 5 C 15 7.76 12.76 10 10 10 C 7.24 10 5 7.76 5 5 C 5 2.24 7.24 0 10 0 Z"/>'


};


